import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';

import { FormPackage } from '../../models/df-package';

@Component({
	selector: 'df-url-box',
	templateUrl: './url-box.component.html',
	styleUrls: ['./url-box.component.scss']
})
export class UrlBoxComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	@Input() urlGlobalRegExp: any;
	constructor() {}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit(): void {}
}
